const scrollTopButton = document.getElementById('scrollToTopBtn');

function throttle(mainFunction, delay) {
  let timerFlag = null;

  return (...args) => {
    if (timerFlag === null) {
      mainFunction(...args);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, delay);
    }
  };
}

function scrollFunction() {
  const scrollTop = document.documentElement.scrollTop;
  const scrolledPercent = (document.documentElement.scrollTop * 100) / document.documentElement.scrollHeight;
  if (scrollTopButton) scrollTopButton.style.display = scrolledPercent > 30 && scrollTop > 500 ? 'flex' : 'none';
}

window.addEventListener('scroll', throttle(scrollFunction, 200));
